import "./assets/css/boxicons.css";
import "./assets/css/core.css";
import "./assets/css/demo.css";
import "./assets/css/theme-default.css";
import "./assets/css/auth.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/style.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Layout from "./components/common/Layout";
import PrivateRoute from "./components/common/PrivateRoute";
import PrivateAdminRoute from "./components/common/PrivateAdminRoute";
import PrivatePermissionRoute from "./components/common/PrivatePermissionRoute";
import LoginPage from "./pages/Login/LoginPage";
import PrivacyPolicyPage from "./pages/Others/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/Others/TermsAndConditionsPage";
import ForumSettingsEdit from "./pages/ForumSettings/ForumSettingsEdit";
import ApplicationProvider from "./context/ApplicationProvider";
import UsersList from "./pages/Users/UsersList";
import UserCreate from "./pages/Users/UserCreate";
import UserEdit from "./pages/Users/UserEdit";
import NewsList from "./pages/News/Newslist";
import NewsCreate from "./pages/News/NewsCreate";
import NewsEdit from "./pages/News/NewsEdit";
import CountryAdminUserList from "./pages/Admin/CountryAdmin/CountryAdminList";
import CountryAdminUserCreate from "./pages/Admin/CountryAdmin/CreateCountryAdmin";
import CountryAdminUserEdit from "./pages/Admin/CountryAdmin/EditCountryAdmin";
import StateAdminUserList from "./pages/Admin/StateAdmin/StateAdminList";
import StateAdminUserCreate from "./pages/Admin/StateAdmin/CreateStateAdmin";
import StateAdminUserEdit from "./pages/Admin/StateAdmin/EditStateAdmin";
import RegionAdminUserList from "./pages/Admin/RegionAdmin/RegionAdminList";
import RegionAdminUserCreate from "./pages/Admin/RegionAdmin/CreateRegionAdmin";
import RegionAdminUserEdit from "./pages/Admin/RegionAdmin/EditRegionAdmin";
import ChapterAdminUserList from "./pages/Admin/ChapterAdmin/ChapterAdminList";
import ChapterAdminUserCreate from "./pages/Admin/ChapterAdmin/CreateChapterAdmin";
import ChapterAdminUserEdit from "./pages/Admin/ChapterAdmin/EditChapterAdmin";
import CountrysList from "./pages/Countrys/CountrysList";
import CreateCountry from "./pages/Countrys/CreateCountry";
import EditCountry from "./pages/Countrys/EditCountry";
import StatesList from "./pages/States/StatesList";
import CreateState from "./pages/States/CreateState";
import EditState from "./pages/States/EditState";
import RegionsList from "./pages/Regions/RegionsList";
import CreateRegion from "./pages/Regions/CreateRegion";
import EditRegion from "./pages/Regions/EditRegion";
import ChaptersList from "./pages/Chapters/ChaptersList";
import CreateChapter from "./pages/Chapters/CreateChapter";
import EditChapter from "./pages/Chapters/EditChapter";
import UserRolesList from "./pages/UserRoles/UserRolesList";
import CreateUserRole from "./pages/UserRoles/CreateUserRole";
import EditUserRole from "./pages/UserRoles/EditUserRole";
import CategoryList from "./pages/Category/CategoryList";
import CreateCategory from "./pages/Category/CreateCategory";
import EditCategory from "./pages/Category/EditCategory";
import BloodgroupList from "./pages/Bloodgroup/BloodgroupList";
import CreateBloodgroup from "./pages/Bloodgroup/CreateBloodgroup";
import EditBloodgroup from "./pages/Bloodgroup/EditBloodgroup";
import CrownsList from "./pages/Crowns/CrownsList";
// import CreateCrown from "./pages/Crowns/CreateCrown";
import EditCrown from "./pages/Crowns/EditCrown";
import IncomeCategoryList from "./pages/IncomeCategory/IncomeCategoryList";
import CreateIncomeCategory from "./pages/IncomeCategory/CreateIncomeCategory";
import EditIncomeCategory from "./pages/IncomeCategory/EditIncomeCategory";
import ExpenseCategoryList from "./pages/ExpenseCategory/ExpenseCategoryList";
import CreateExpenseCategory from "./pages/ExpenseCategory/CreateExpenseCategory";
import EditExpenseCategory from "./pages/ExpenseCategory/EditExpenseCategory";
import PostsCategoryList from "./pages/PostsCategory/PostsCategoryList";
import CreatePostsCategory from "./pages/PostsCategory/CreatePostsCategory";
import EditPostsCategory from "./pages/PostsCategory/EditPostsCategory";
import SponsorsCategoryList from "./pages/SponsorsCategory/SponsorsCategoryList";
import CreateSponsorCategory from "./pages/SponsorsCategory/CreateSponsorCategory";
import EditSponsorCategory from "./pages/SponsorsCategory/EditSponsorCategory";
import FeedPostsList from "./pages/FeedPosts/FeedPostsList";
import FeedPostEdit from "./pages/FeedPosts/FeedPostEdit";
import IncomesList from "./pages/Incomes/IncomesList";
import IncomeEdit from "./pages/Incomes/IncomeEdit";
import ExpensesList from "./pages/Expenses/ExpensesList";
import ExpenseEdit from "./pages/Expenses/ExpenseEdit";
import SponsorsList from "./pages/Sponsors/SponsorsList";
import SponsorEdit from "./pages/Sponsors/SponsorEdit";


import TimersList from "./pages/Timers/TimersList";
import CreateTimer from "./pages/Timers/CreateTimer";
import EditTimer from "./pages/Timers/EditTimer";
import EditTimerAccess from "./pages/Timers/EditTimerAccess";
import EditChapterFinanceAccess from "./pages/ChapterFinanceAccess/EditChapterFinanceAccess";
import RolesList from "./pages/Roles/RolesList";
import CreateRole from "./pages/Roles/CreateRole";
import EditRole from "./pages/Roles/EditRole";
import TyfcbList from "./pages/Tyfcb/TyfcbList";
import TyfcbEdit from "./pages/Tyfcb/TyfcbEdit";
import WeeklyMeetingsList from "./pages/MeetingSchedules/WeeklyMeetingsList";
import SchedulesList from "./pages/MeetingSchedules/SchedulesList";
import OnetoOneList from "./pages/OnetoOne/OnetoOneList";
import OnetoOneEdit from "./pages/OnetoOne/OnetoOneEdit";
import ReferralsList from "./pages/Referrals/ReferralsList";
import ReferralEdit from "./pages/Referrals/ReferralEdit";
import VisitorsList from "./pages/Visitors/VisitorsList";
import VisitorEdit from "./pages/Visitors/VisitorEdit";
import ChangePassword from "./pages/Login/ChangePassword";
import Settings from "./pages/Login/Settings";
import Logout from "./pages/Login/Logout";
import WeeklyFeesList from "./pages/MeetingSchedules/WeeklyFeesList";
import EventsList from "./pages/Events/EventsList";
import CreateEvent from "./pages/Events/CreateEvent";
import EditEvent from "./pages/Events/EditEvent";

import TyfcbReportsList from "./pages/Reports/TyfcbReportsList";
import BizgivenReportsList from "./pages/Reports/BizgivenReportsList";
import OnetoOneReportsList from "./pages/Reports/OnetoOneReportsList";
import ReferralsReportsList from "./pages/Reports/ReferralsReportsList";
import VisitorsReportsList from "./pages/Reports/VisitorsReportsList";
import FeesReportsList from "./pages/Reports/FeesReportsList";
import OverallReportsList from "./pages/Reports/OverallReportsList";
import AttendanceReportsList from "./pages/Reports/AttendanceReportsList";
import PointsReportsList from "./pages/Reports/PointsReportsList";
import LedgerReportsList from "./pages/Reports/LedgerReportsList";
import MembershipExpiryRenewalReportsList from "./pages/Reports/MembershipExpiryRenewalReportsList";

import TestimonialsList from "./pages/Testimonials/TestimonialsList";
import TestimonialEdit from "./pages/Testimonials/TestimonialEdit";
import PointsSystem from "./pages/Points/PointsSystem";

function App() {
  return (
    <>
      <ApplicationProvider>
        <ToastContainer theme="colored" autoClose={3000} />
        <Router>
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Layout />}>
                <Route
                  element={<PrivatePermissionRoute permission="dashboard-view" />}
                >
                  <Route index path="/" element={<Dashboard />} />
                  <Route index path="/home" element={<Dashboard />} />
                  <Route index path="/dashboard" element={<Dashboard />} />
                </Route>
                <Route path="/change-password" element={<ChangePassword />} />
                <Route
                  element={
                    <PrivatePermissionRoute permission="settings-list" />
                  }
                >
                  <Route path="/settings" element={<Settings />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="members-list" />}
                >
                  <Route path="/users" element={<UsersList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="members-create" />
                  }
                >
                  <Route path="/user/create" element={<UserCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="members-edit" />}
                >
                  <Route path="/user/:id/edit" element={<UserEdit />} />
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 2, 3, 6, 7]} />}>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="user-roles-list" />
                    }
                  >
                    <Route path="/user-roles" element={<UserRolesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="user-role-create" />
                    }
                  >
                    <Route
                      path="/create/user-role"
                      element={<CreateUserRole />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="user-role-edit" />
                    }
                  >
                    <Route
                      path="/user-role/:id/edit"
                      element={<EditUserRole />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-list" />
                    }
                  >
                    <Route path="/category" element={<CategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-create" />
                    }
                  >
                    <Route
                      path="/create/category"
                      element={<CreateCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-edit" />
                    }
                  >
                    <Route
                      path="/category/:id/edit"
                      element={<EditCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="income-category-list" />
                    }
                  >
                    <Route path="/income-category" element={<IncomeCategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="income-category-create" />
                    }
                  >
                    <Route
                      path="/create/income-category"
                      element={<CreateIncomeCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="income-category-edit" />
                    }
                  >
                    <Route
                      path="/income-category/:id/edit"
                      element={<EditIncomeCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="expense-category-list" />
                    }
                  >
                    <Route path="/expense-category" element={<ExpenseCategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="expense-category-create" />
                    }
                  >
                    <Route
                      path="/create/expense-category"
                      element={<CreateExpenseCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="expense-category-edit" />
                    }
                  >
                    <Route
                      path="/expense-category/:id/edit"
                      element={<EditExpenseCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="posts-category-list" />
                    }
                  >
                    <Route path="/posts-category" element={<PostsCategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="posts-category-create" />
                    }
                  >
                    <Route
                      path="/create/posts-category"
                      element={<CreatePostsCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="posts-category-edit" />
                    }
                  >
                    <Route
                      path="/posts-category/:id/edit"
                      element={<EditPostsCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="sponsors-category-list" />
                    }
                  >
                    <Route path="/sponsors-category" element={<SponsorsCategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="sponsors-category-create" />
                    }
                  >
                    <Route
                      path="/create/sponsors-category"
                      element={<CreateSponsorCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="sponsors-category-edit" />
                    }
                  >
                    <Route
                      path="/sponsors-category/:id/edit"
                      element={<EditSponsorCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-groups-list" />
                    }
                  >
                    <Route path="/blood-groups" element={<BloodgroupList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-group-create" />
                    }
                  >
                    <Route
                      path="/create/blood-group"
                      element={<CreateBloodgroup />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-group-edit" />
                    }
                  >
                    <Route
                      path="/blood-group/:id/edit"
                      element={<EditBloodgroup />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="crowns-list" />
                    }
                  >
                    <Route path="/crowns" element={<CrownsList />} />
                  </Route>
                  {/* <Route
                    element={
                      <PrivatePermissionRoute permission="crowns-create" />
                    }
                  >
                    <Route
                      path="/create/crown"
                      element={<CreateCrown />}
                    />
                  </Route> */}
                  <Route
                    element={
                      <PrivatePermissionRoute permission="crowns-edit" />
                    }
                  >
                    <Route
                      path="/crown/:id/edit"
                      element={<EditCrown />}
                    />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="timers-list" />}
                  >
                    <Route path="/timers" element={<TimersList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="timer-create" />
                    }
                  >
                    <Route path="/create/timer" element={<CreateTimer />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="timer-edit" />}
                  >
                    <Route path="/timer/:id/edit" element={<EditTimer />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="timer-access-list" />
                    }
                  >
                    <Route path="/timer-access" element={<EditTimerAccess />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-finance-access-list" />
                    }
                  >
                    <Route path="/chapter-finance-access" element={<EditChapterFinanceAccess />} />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1]} />}>
                  <Route
                    element={<PrivatePermissionRoute permission="roles-list" />}
                  >
                    <Route path="/roles" element={<RolesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="role-create" />
                    }
                  >
                    <Route path="/create/role" element={<CreateRole />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="role-edit" />}
                  >
                    <Route path="/role/:id/edit" element={<EditRole />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-list" />
                    }
                  >
                    <Route path="/countries" element={<CountrysList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-create" />
                    }
                  >
                    <Route path="/create/country" element={<CreateCountry />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-edit" />
                    }
                  >
                    <Route path="/country/:id/edit" element={<EditCountry />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admins-list" />
                    }
                  >
                    <Route
                      path="/country-admin-users"
                      element={<CountryAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admin-create" />
                    }
                  >
                    <Route
                      path="/country-admin-user/create"
                      element={<CountryAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admin-edit" />
                    }
                  >
                    <Route
                      path="/country-admin-user/:id/edit"
                      element={<CountryAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6]} />}>
                  <Route
                    element={<PrivatePermissionRoute permission="states-list" />}
                  >
                    <Route path="/states" element={<StatesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-create" />
                    }
                  >
                    <Route path="/create/state" element={<CreateState />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="state-edit" />}
                  >
                    <Route path="/state/:id/edit" element={<EditState />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admins-list" />
                    }
                  >
                    <Route
                      path="/state-admin-users"
                      element={<StateAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admin-create" />
                    }
                  >
                    <Route
                      path="/state-admin-user/create"
                      element={<StateAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admin-edit" />
                    }
                  >
                    <Route
                      path="/state-admin-user/:id/edit"
                      element={<StateAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6, 7]} />}>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-list" />
                    }
                  >
                    <Route path="/regions" element={<RegionsList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-create" />
                    }
                  >
                    <Route path="/create/region" element={<CreateRegion />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-edit" />
                    }
                  >
                    <Route path="/region/:id/edit" element={<EditRegion />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admins-list" />
                    }
                  >
                    <Route
                      path="/region-admin-users"
                      element={<RegionAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admin-create" />
                    }
                  >
                    <Route
                      path="/region-admin-user/create"
                      element={<RegionAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admin-edit" />
                    }
                  >
                    <Route
                      path="/region-admin-user/:id/edit"
                      element={<RegionAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route
                  element={<PrivateAdminRoute allowedRoles={[1, 6, 7, 2, 3]} />}
                >
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-list" />
                    }
                  >
                    <Route path="/chapters" element={<ChaptersList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-create" />
                    }
                  >
                    <Route path="/create/chapter" element={<CreateChapter />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-edit" />
                    }
                  >
                    <Route path="/chapter/:id/edit" element={<EditChapter />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admins-list" />
                    }
                  >
                    <Route
                      path="/chapter-admin-users"
                      element={<ChapterAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admin-create" />
                    }
                  >
                    <Route
                      path="/chapter-admin-user/create"
                      element={<ChapterAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admin-edit" />
                    }
                  >
                    <Route
                      path="/chapter-admin-user/:id/edit"
                      element={<ChapterAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="tyfcbs-list" />}
                >
                  <Route path="/tyfcbs" element={<TyfcbList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="tyfcbs-edit" />}
                >
                  <Route path="/tyfcbs/:id/edit" element={<TyfcbEdit />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="fbms-list" />
                  }
                >
                  <Route path="/one-to-one" element={<OnetoOneList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="fbms-edit" />}
                >
                  <Route path="/one-to-one/:id/edit" element={<OnetoOneEdit />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="referrals-list" />
                  }
                >
                  <Route path="/referrals" element={<ReferralsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="referrals-edit" />
                  }
                >
                  <Route path="/referrals/:id/edit" element={<ReferralEdit />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-general-list" />
                  }
                >
                  <Route
                    path="/visitors/general"
                    element={
                      <VisitorsList visitType="0" visitTypeText="General" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-general-edit" />
                  }
                >
                  <Route
                    path="/visitors/general/:id/edit"
                    element={<VisitorEdit />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-chief-guest-list" />
                  }
                >
                  <Route
                    path="/visitors/chief-guest"
                    element={
                      <VisitorsList visitType="1" visitTypeText="Chief Guest" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-chief-guest-edit" />
                  }
                >
                  <Route
                    path="/visitors/chief-guest/:id/edit"
                    element={<VisitorEdit />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-power-date-list" />
                  }
                >
                  <Route
                    path="/visitors/power-date"
                    element={
                      <VisitorsList visitType="2" visitTypeText="Power Date" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-power-date-edit" />
                  }
                >
                  <Route
                    path="/visitors/power-date/:id/edit"
                    element={<VisitorEdit />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-inductions-list" />
                  }
                >
                  <Route
                    path="/visitors/inductions"
                    element={
                      <VisitorsList visitType="3" visitTypeText="Inductions" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-inductions-edit" />
                  }
                >
                  <Route
                    path="/visitors/inductions/:id/edit"
                    element={<VisitorEdit />}
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="weekly-attendance-list" />}
                >
                  <Route path="/weekly-meetings" element={<WeeklyMeetingsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="weekly-attendance-list" />}
                >
                  <Route
                    path="/meeting-schedules"
                    element={<SchedulesList />}
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="meeting-fees-list" />}
                >
                  <Route path="/meeting-fees" element={<WeeklyFeesList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="events-list" />}
                >
                  <Route path="/events" element={<EventsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="events-create" />
                  }
                >
                  <Route path="/create/event" element={<CreateEvent />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="events-edit" />}
                >
                  <Route path="/event/:id/edit" element={<EditEvent />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="feed-posts-list" />}
                >
                  <Route path="/feed-posts" element={<FeedPostsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="feed-posts-edit" />}
                >
                  <Route path="/feed-posts/:id/edit" element={<FeedPostEdit />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="incomes-list" />}
                >
                  <Route path="/incomes" element={<IncomesList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="incomes-edit" />}
                >
                  <Route path="/incomes/:id/edit" element={<IncomeEdit />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="expenses-list" />}
                >
                  <Route path="/expenses" element={<ExpensesList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="expenses-edit" />}
                >
                  <Route path="/expenses/:id/edit" element={<ExpenseEdit />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="sponsors-list" />}
                >
                  <Route path="/sponsors" element={<SponsorsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="sponsors-edit" />}
                >
                  <Route path="/sponsors/:id/edit" element={<SponsorEdit />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-list" />}
                >
                  <Route path="/news" element={<NewsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-create" />}
                >
                  <Route path="/news/create" element={<NewsCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-edit" />}
                >
                  <Route path="/news/:id/edit" element={<NewsEdit />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="testimonials-list" />
                  }
                >
                  <Route path="/testimonials" element={<TestimonialsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="testimonials-edit" />
                  }
                >
                  <Route
                    path="/testimonials/:id/edit"
                    element={<TestimonialEdit />}
                  />
                </Route>

                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-ledger-list" />
                  }
                >
                  <Route
                    path="/reports/ledger"
                    element={<LedgerReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-membership-expiry-renewal-list" />
                  }
                >
                  <Route
                    path="/reports/membership-expiry-renewals"
                    element={<MembershipExpiryRenewalReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-tyns-list" />
                  }
                >
                  <Route
                    path="/reports/tyfcbs"
                    element={<TyfcbReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-biz-given-list" />
                  }
                >
                  <Route
                    path="/reports/biz-given"
                    element={<BizgivenReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-fbms-list" />
                  }
                >
                  <Route
                    path="/reports/one-to-one"
                    element={<OnetoOneReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-referrals-list" />
                  }
                >
                  <Route
                    path="/reports/referrals"
                    element={<ReferralsReportsList />}
                  />
                </Route>

                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-visitors-list" />
                  }
                >
                  <Route
                    path="/reports/visitors"
                    element={<VisitorsReportsList />}
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="reports-reward-points" />}
                >
                  <Route path="/reports/points" element={<PointsReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-fees-list" />
                  }
                >
                  <Route path="/reports/fees" element={<FeesReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-attendance-list" />
                  }
                >
                  <Route
                    path="/reports/attendance"
                    element={<AttendanceReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-overall-list" />
                  }
                >
                  <Route
                    path="/reports/overall"
                    element={<OverallReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="points-system-list" />
                  }
                >
                  <Route path="/points-system" element={<PointsSystem />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="forum-settings-list" />
                  }
                >
                  <Route
                    path="/forum-settings"
                    element={<ForumSettingsEdit />}
                  />
                </Route>
                <Route path="/logout" element={<Logout />} />
              </Route>
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditionsPage />}
            />
          </Routes>
        </Router>
      </ApplicationProvider>
    </>
  );
}

export default App;
